import { 
	TEST_SUCCESS,
	TEST_BEGIN,
	TEST_FAILURE,
	CLEAR_TEST,
	TEST_FILTER_SUCCESS,
	TEST_FILTER_BEGIN,
	TEST_FILTER_FAILURE,
	CLEAR_TEST_FILTER,
	TEST_QUIESTION_SUCCESS,
	TEST_QUIESTION_BEGIN,
	TEST_QUIESTION_FAILURE,
	CLEAR_TEST_QUIESTION,
	EXPORT_SUCCESS,
	EXPORT_BEGIN,
	EXPORT_FAILURE,
	CLEAR_EXPORT,
} from 'app/actions/TestActions';

const initialState = {
	byId: {},
	allIds: [],
	allTestQuestion: [],
	filterData: [],
	exportData: [],
	isLoading: false,
};

export default function TestReducer (state = initialState, action) {
	switch (action.type) {
		case TEST_BEGIN: 
			return {
				...state,
				isLoading: true
			}
		case TEST_SUCCESS: 
			let allIds = action.payload.data.Data;
			let byId = {
				...state.byId,
			};
			return {
				...state,
				allIds,
				byId,
				isLoading: false,
			};
		case CLEAR_TEST:
			return {
				...state,
				byId: {},
				allIds: [],
				isLoading: false, 
			}
		case TEST_FAILURE: 
			return {
				...state,
				isLoading: false
			}

		case TEST_QUIESTION_BEGIN: 
			return {
				...state,
				isLoading: true
			}

		case TEST_QUIESTION_SUCCESS: 
			let allTestQuestion = [...new Set(state.allTestQuestion.concat(action.payload.data.all))];
		
			return {
				...state,
					allTestQuestion,
					isLoading: false,
				};
		case CLEAR_TEST_QUIESTION:
			return {
					...state,
				allTestQuestion: [],
				isLoading: false, 
			}
		case TEST_QUIESTION_FAILURE: 
			return {
				...state,
				isLoading: false
			}
		case TEST_FILTER_BEGIN: 
			return {
				...state,
				isLoading: true
			}
		case TEST_FILTER_SUCCESS: 
		let filterData = [...new Set(state.filterData.concat(action.payload.data))];
			return {
				...state,
				filterData,
				isLoading: false,
			};
		case CLEAR_TEST_FILTER:
			return {
				...state,
				filterData: [],
				isLoading: false, 
			}
		case TEST_FILTER_FAILURE: 
			return {
				...state,
				isLoading: false
			}
		case EXPORT_BEGIN: 
			return {
				...state,
				isLoading: true
			}
		case EXPORT_SUCCESS: 
		let exportData = [...new Set(state.exportData.concat(action.payload.data.Data))];
			return {
				...state,
				exportData,
				isLoading: false,
			};
		case CLEAR_EXPORT:
			return {
				...state,
				exportData: [],
				isLoading: false, 
			}
		case EXPORT_FAILURE: 
			return {
				...state,
				isLoading: false
			}
	
		default:
			return state;
			}
		};
		
export const getTest = state => {
	return state.allIds;
}
export const getIsLoadingTest =  state => {
	return state.isLoading;
}
		
export const getTestQuestion = state => {
	return state.allTestQuestion;
}
export const getIsLoadingTestQuestion=  state => {
	return state.isLoading;
}

export const getTestFilter = state => {
	return state.filterData
}
export const getIsLoadingTestFilter =  state => {
	return state.isLoading;
}

export const getExport = state => {
	return state.exportData
}
export const getIsLoadingExport =  state => {
	return state.isLoading;
}